<template>
  <div>
    <div class="d-flex justify-content-center align-items-center flex-column">
      <b-collapse
        id="collapse-submenu-2"
        v-model="showSubMenu"
        visible
        class="d-flex justify-content-center"
      >
        <div v-if="showSubMenu" class="secondary-box">
          <div class="w-100 d-inline-flex align-items-start justify-content-between">
            <div class="d-flex align-items-center">
              <div class="presence-indicator-icon-box">
                <font-awesome-icon icon="user" size="lg" />
              </div>
              <div class="px-2 font-12">
                <div>
                  Physiquement présents
                </div>
                <div>
                  <strong>{{ presentMandates }}</strong>
                </div>
              </div>
            </div>
            <font-awesome-icon
              v-if="!isBeforeMeetingStart"
              class="cursor-pointer arrow-down-icon"
              icon="angle-double-down"
              size="2x"
              @click="toggleSubMenu"
            />
          </div>
          <div class="w-100 d-inline-flex align-items-center">
            <div class="presence-indicator-icon-box">
              <font-awesome-icon icon="user-tag" size="lg" />
            </div>
            <div class="px-2 font-12">
              <div>
                Représentés par une personne présente physiquement
              </div>
              <div>
                <strong>{{ representedMandates }}</strong>
              </div>
            </div>
          </div>
          <div class="w-100 d-inline-flex align-items-center">
            <div class="presence-indicator-icon-box">
              <font-awesome-icon icon="video" size="lg" />
            </div>
            <div class="px-2 font-12">
              <div>
                Connecté en ligne
              </div>
              <div>
                <strong>{{ videoMandates }}</strong>
              </div>
            </div>
          </div>
          <div class="w-100 d-inline-flex align-items-center">
            <div>
              <b-img
                class="video-tag-icon"
                :src="require('@/assets/images/video-tag.svg')"
                fluid
                alt="VideoTag"
              >
              </b-img>
            </div>
            <div class="px-2 font-12">
              <div>
                Représentés par une personne en ligne
              </div>
              <div>
                <strong>{{ representedVideoMandates }}</strong>
              </div>
            </div>
          </div>
          <div class="w-100 d-inline-flex align-items-center">
            <div class="presence-indicator-icon-box">
              <font-awesome-icon icon="envelope" size="lg" />
            </div>
            <div class="px-2 font-12">
              <div>
                Correspondance
              </div>
              <div>
                <strong>{{ correspondenceMandates }}</strong>
              </div>
            </div>
          </div>
          <div v-if="!isBeforeMeetingStart" class="w-100 d-inline-flex align-items-center">
            <div class="presence-indicator-icon-box">
              <font-awesome-icon icon="user-plus" size="lg" />
            </div>
            <div class="px-2 font-12">
              <div>
                Invités
              </div>
              <div>
                <strong>{{ meetingGuests }}</strong>
              </div>
            </div>
          </div>
          <div v-if="!isBeforeMeetingStart" class="w-100 d-inline-flex align-items-center">
            <div class="presence-indicator-icon-box">
              <font-awesome-icon icon="envelope" size="sm" />
              <font-awesome-icon icon="question-circle" size="sm" class="ml-1 mt-3" />
            </div>
            <div class="px-2 font-12">
              <div>
                Correspondance ignorée
              </div>
              <div>
                <strong>{{ ignoredCorrespondenceMandates }}</strong>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
      <div v-if="!showSubMenu" class="secondary-box expand-secondary-box" @click="toggleSubMenu">
        <div class="w-100 d-flex justify-content-end cursor-pointer">
          <font-awesome-icon class="mr-2" icon="angle-double-up" size="lg" />
          <div class="font-12">
            Voir plus
          </div>
        </div>
      </div>
      <div class="main-box mb-3 w-100">
        <div class="w-100 d-flex flex-column align-items-start">
          <div class="w-100 d-inline-flex align-items-center">
            <div class="small-card">
              <font-awesome-icon icon="user-check" size="2x" />
            </div>
            <div class="px-2">
              <div>
                Présents, représentés ou votants par correspondance
              </div>
              <div>
                <strong>
                  {{
                    presentMandates +
                    representedMandates +
                    videoMandates +
                    representedVideoMandates +
                    correspondenceMandates
                  }}
                </strong>
              </div>
            </div>
          </div>
          <div class="w-100 d-inline-flex align-items-center my-2">
            <div class="small-card">
              <font-awesome-icon icon="user-times" size="2x" />
            </div>
            <div class="px-2">
              <div>
                Absents non représentés
              </div>
              <div>
                <strong>{{ absentMandates + ignoredCorrespondenceMandates }}</strong>
              </div>
            </div>
          </div>
          <div class="row w-100">
            <b-col cols="12" xl="7" class="d-inline-flex align-items-center">
              <div class="small-card">
                <font-awesome-icon icon="users" size="2x" />
              </div>
              <div class="px-2">
                <div>
                  <!-- Copropriétaires -->
                  Total des copropriétaires
                </div>
                <div>
                  <strong>{{ allMandates }}</strong>
                </div>
              </div>
            </b-col>
            <b-col
              v-if="!isBeforeMeetingStart"
              cols="12"
              xl="5"
              class="d-flex align-items-center justify-content-start justify-content-xl-end mt-3 mt-xl-0"
            >
              <font-awesome-icon id="popover-presence" icon="info-circle" size="1x" class="mx-2" />
              <b-popover target="popover-presence" triggers="hover" placement="top">
                {{ presenceButtonInfoBoxText }}
              </b-popover>
              <b-button class="w-75" variant="outline-dark" @click="toggleArrivedLeftPressed">
                Présence
              </b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    presentMandates: {
      type: Number,
      default: 0,
    },
    representedMandates: {
      type: Number,
      default: 0,
    },
    videoMandates: {
      type: Number,
      default: 0,
    },
    representedVideoMandates: {
      type: Number,
      default: 0,
    },
    correspondenceMandates: {
      type: Number,
      default: 0,
    },
    ignoredCorrespondenceMandates: {
      type: Number,
      default: 0,
    },
    absentMandates: {
      type: Number,
      default: 0,
    },
    allMandates: {
      type: Number,
      default: 0,
    },
    meetingGuests: {
      type: Number,
      default: 0,
    },
    presenceButtonInfoBoxText: {
      type: String,
      default: "",
    },
    isBeforeMeetingStart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSubMenu: false,
    };
  },
  created() {
    if (this.isBeforeMeetingStart) {
      this.showSubMenu = this.isBeforeMeetingStart;
    }
  },
  methods: {
    toggleArrivedLeftPressed() {
      this.$emit("toggleArrivedLeftPressed");
    },
    toggleSubMenu() {
      this.showSubMenu = !this.showSubMenu;
    },
  },
};
</script>
